/* eslint-disable react/jsx-max-depth */

import { BrowserRouter } from 'react-router-dom';

// TODO: DREGAB-23042 Move browserslist into react-components import { BrowserNotSupportedSnackbar } from '@libs/browserslist';
import { CqrsClientProvider } from '@dreryk/command-query-react-common';
import {
   GlobalErrorBoundary,
   SecurityDependenciesContextProvider,
   SecurityRoutes,
   SystemId,
} from '@dreryk/egabinet-security-frontend';
import {
   CookiesConsentSnackbar,
   DarkTheme,
   MainLayout,
   PromptGlobalListener,
   SnackbarEventListener,
   StandardTheme,
   ThemeProvider,
} from '@dreryk/react-components';

import { CqrsWebsocket } from '~libs.shared.system';
import { PractitionerUpdatedEventListener } from '~libs.shared.account';

import { AppMainMenu } from './AppMainMenu';
import { AppRoutes } from './AppRoutes';
import { LegacyAnalytics } from './components/LegacyAnalytics';
import { SalesMode } from './components/SalesMode';
import { LocationLogger } from './development/LocationLogger';
import { MobileVersionAvailableModal } from './features/mobileVersionAvailableModal/MobileVersionAvailableModal';
import { MainToolbar } from './toolbar/MainToolbar';
import { AppAnalytics } from './AppAnalytics';
import { useFaultHandlerMap } from './faultHandlerMap';
import { AppInitializer } from './AppInitializer';

export const App = (): JSX.Element => {
   const faultHandlerMap = useFaultHandlerMap();

   return (
      <ThemeProvider light={StandardTheme} dark={DarkTheme}>
         <GlobalErrorBoundary>
            <CqrsClientProvider>
               <BrowserRouter>
                  <SnackbarEventListener />
                  <PromptGlobalListener />
                  <LocationLogger />
                  <SecurityDependenciesContextProvider
                     systemId={SystemId.E_GABINET}
                     ExternalLoginModal={MobileVersionAvailableModal}
                     faultHandlerMap={faultHandlerMap}
                  >
                     <SecurityRoutes
                        authorizedRoutes={
                           <>
                              <AppInitializer>
                                 <MainLayout menu={<AppMainMenu />} toolbar={<MainToolbar />} testId={'mainLayout'}>
                                    <AppRoutes />
                                 </MainLayout>
                              </AppInitializer>
                              <AppAnalytics />
                              <CqrsWebsocket />
                              <PractitionerUpdatedEventListener />
                           </>
                        }
                     >
                        <LegacyAnalytics />
                        <CookiesConsentSnackbar />
                        {/* TODO: DREGAB-23042 Move Browserlist into react-components <BrowserNotSupportedSnackbar />  */}
                        <SalesMode />
                     </SecurityRoutes>
                  </SecurityDependenciesContextProvider>
               </BrowserRouter>
            </CqrsClientProvider>
         </GlobalErrorBoundary>
      </ThemeProvider>
   );
};
